"use client"
import { GetPageQuery } from "apollo";
import { ScrollingProvider } from "contexts/ScrollingContext";
import QRCodeCharge from "pazChargeComponents/Home/QRCodeCharge";
import QuestionListBlockCharge from "pazChargeComponents/Home/QuestionListBlockCharge";
import StickyButtonNav from "pazChargeComponents/Home/SitckyButtonNavigatorCharge";
import VideoBlockCharge, { VideoBlockChargePropsBGColor } from "pazChargeComponents/Home/VideoBlockCharge";
import { Desktop, Mobile } from "ui";
import { BlockRenderer, extractProperty, findProperty } from "utils";
import ChargeBenefitsContentBlock from "./ChargeBenefitsContentBlock";
import ImageWithTextCharge from "./ImageAndTextCharge";
import ImageBlockChrage from "./ImageBlockCharge";
import VideoCarouselBlockCharge from "./VideoCarouselBlockCharge";
import WalletWrapperChargeBlock from "./WalletWrapperChargeBlock";

type Props = {
    data: GetPageQuery
}

const components = {
    chargeHeader: ImageWithTextCharge,
    chargeBenefitsContentBlock: ChargeBenefitsContentBlock,
    chargeMiddleBanner: ImageBlockChrage,
    chargeHowTo: VideoCarouselBlockCharge,
    // baseBlock: StationTypeCharge,
    wallet: WalletWrapperChargeBlock,
    chargeVideoBlock: VideoBlockCharge,
    chargeQuestionsList: QuestionListBlockCharge
}


function PublicStationsChargePage({ data }: Props) {
    if (!data) {
        return null
    }

    const pageName = extractProperty(data?.page, "pageName")

    return (
        <>
            <Desktop>
                <QRCodeCharge showScrollIcon></QRCodeCharge>
            </Desktop>
            <Mobile>
                <StickyButtonNav />
                <QRCodeCharge showQRCode={false} showScrollIcon></QRCodeCharge>
            </Mobile>

            <ScrollingProvider pageName={pageName} minOffsetShow={350} smallDesktopMaxWidth={180}>
                {findProperty(data?.page, "blocks")?.blocks?.map(
                    // TO DO : HOW TO FIND BLOCK TYPE IN GENERATED GRAPHQL TYPES
                    (block: any, index: number) => {
                        const sideMenuTitle = block.properties.find(
                            (prop: any) => prop.propertyName === "sideMenuTitle",
                        )?.propertyValue?.value
                        let addProp;
                        if (block.blockType === "chargeVideoBlock") {
                            addProp = {
                                backgroundColor: VideoBlockChargePropsBGColor.LIGHT_GRAY,
                            }
                        } else if (block.blockType === "chargeHeader") {
                            addProp = {
                                titleMargin: false,
                                showMobileScroll: true,
                                pageName
                            }
                        }
                        if (block) {
                            return (
                                <section key={sideMenuTitle} id={sideMenuTitle || `page : ${index.toString()}`}>
                                    <BlockRenderer
                                        index={index}
                                        key={index}
                                        blockType={block.blockType}
                                        blockData={block}
                                        components={components}
                                        props={addProp}
                                    >
                                    </BlockRenderer>
                                </section>
                            )
                        }
                    },
                )}
            </ScrollingProvider>
        </>);
}

export default PublicStationsChargePage;
